module.exports = __webpack_public_path__ + "static/img/betting-coupon-500000.ca5a96b.png";